import { BadgeColorKeys } from '@/components/ui/badge/badge.types'
import { PersonDisplay } from '@/models/features/display-column.models'

export type VisitorStatus = 'active' | 'expired' | 'banned' | 'suspended'

export const visitorStatusBadgeColorMap: Record<VisitorStatus, BadgeColorKeys> = {
  active: 'green',
  banned: 'red',
  expired: 'neutral',
  suspended: 'orange',
}

export interface GuestModel {
  // Note: the BE's per-column person details - only the fields enabled in its settings (EL-15064)
  residentDisplay?: PersonDisplay
  id: number
  clientId: number
  name: string
  type?: string
  phone?: string
  mode?: string
  permissions?: string
  startTime?: string
  endTime?: string
  periodicity?: string | string[]
  monthlyPermission?: string
  lastCheckIn?: string
  residentName?: string
  // Note: the per-field resident details aren't sent by /client-guest-with-count yet (EL-15067
  // only extended /visitor) - mapped here so the cell picks them up once the BE adds them.
  residentFirstName?: string | null
  residentLastName?: string | null
  residentAvatar?: string | null
  residentEmail?: string | null
  residentBuildingNumber?: string | null
  residentStreet?: string | null
  unit?: string
  residentPhone?: string
  permissionToEnter?: boolean
  pinCode?: boolean
  keyAccess?: boolean
  keylessAccess?: boolean
  customAccess?: boolean
  status: VisitorStatus
  banned: boolean
  suspended: boolean
}

export interface VendorModel {
  id: number
  name: string
  phone?: string
  mode?: string
  permissions?: string
  startTime?: string
  endTime?: string
  periodicity?: string | string[]
  monthlyPermission?: string
  lastCheckIn?: string
  coi?: boolean
  permissionToEnter?: boolean
  pinCode?: boolean
  keyAccess?: boolean
  keylessAccess?: boolean
  customAccess?: boolean
  status: VisitorStatus
  banned: boolean
  suspended: boolean
}

export interface VisitorHistoryModel {
  visitorId: number
  type: 'guest' | 'vendor'
  name: string
  date: string | number
  status?: VisitorStatus
  mode?: string
  permissions?: string
  startTime?: string
  endTime?: string
  periodicity?: string | string[]
  monthlyPermission?: string
  clientId?: number
  client?: string
  unit?: string
  phone?: string
  permissionToEnter?: boolean
}
